import { useContext, useState } from 'react';
import { StyleContext } from '../../providers/StyleContextProvider';
import { Candidate } from '../../models/Candidate';
import { formatDateWithSuperscript } from '../../helpers/Common';

interface Props {
    selectedCandidate: Candidate;
}

export const ProfileTab: React.FC<Props> = (props) => {
    const styleContext = useContext(StyleContext);
    const tabStyles = styleContext.getComponentStyle("candidatePoolTabs");
    const styles = tabStyles.profileTab;
    const [showFullSummary, setShowFullSummary] = useState(false);

    const handleShowFullSummary = () => {
        setShowFullSummary(!showFullSummary);
    };

    return (
        <>
            <p style={styles.title}>Profile</p>
            {props.selectedCandidate?.personalSummary && <div style={styles.personalSummary}>
                    <div style={styles.personalSummary.title}>{"Personal Summary"}</div>
                    <div style={styles.personalSummary.text}>
                        {showFullSummary
                            ? props.selectedCandidate?.personalSummary
                            : `${props.selectedCandidate?.personalSummary.substring(0, 180)}...`
                        }   
                        {props.selectedCandidate.personalSummary.length > 180 && (
                            <span onClick={() => handleShowFullSummary()} style={styles.seeMore}>
                                {showFullSummary ? "See Less" : "See More"}
                            </span>
                        )}  
                    </div>
            </div>}
            <div style={styles.details}>
                {props.selectedCandidate?.email && <div style={styles.details.box}>
                    <div style={styles.details.title}>{"Email Address"}</div>
                    <div style={styles.details.text}>{props.selectedCandidate.email}</div>
                </div>}
                {props.selectedCandidate?.mobileNumber && <div style={styles.details.box}>
                    <div style={styles.details.title}>{"Mobile Number"}</div>
                    <div style={styles.details.text}>{props.selectedCandidate?.mobileNumber}</div>
                </div>}
                {props.selectedCandidate?.telephone && <div style={styles.details.box}>
                    <div style={styles.details.title}>{"Telephone"}</div>
                    <div style={styles.details.text}>{props.selectedCandidate.telephone}</div>
                </div>}
                {props.selectedCandidate?.address1 && <div style={styles.details.box}>
                    <div style={styles.details.title}>{"Address"}</div>
                    <div style={styles.details.text}>{props.selectedCandidate.address1}</div>
                </div>}
                {props.selectedCandidate?.createdDate && <div style={styles.details.box}>
                    <div style={styles.details.title}>{"Date Created"}</div>
                    <div style={styles.details.text}>{formatDateWithSuperscript(props.selectedCandidate.createdDate)}</div>
                </div>}
                {props.selectedCandidate?.lastUpdatedDate && <div style={styles.details.box}>
                    <div style={styles.details.title}>{"Last Modified"}</div>
                    <div style={styles.details.text}>{formatDateWithSuperscript(props.selectedCandidate.lastUpdatedDate)}</div>
                </div>}
            </div>
        </>
    );
}